import strings from 'localization/strings';
import { email, emailOptional, phoneNumber, phoneNumberOptional } from 'form/validation';
import additionalServiceTypes from 'enums/additionalServiceTypes';
import lockTypes from 'enums/lockTypes';
import { showErrorOnBlur } from 'mui-rff';

export const getAdditionalServiceConfiguration = (additionalService, storageSite, isAdmin = false) => {
    if(!additionalService) {
        return undefined;
    }
    if(additionalService?.type === additionalServiceTypes.lockSystemAdditionalUser.key) {
        if(storageSite.lockType === lockTypes.parakey.key) {
            return {
                showDataTextbox: true,
                dataTextboxProps: {
                    label: strings.email,
                    helperText: strings.lockSystemAdditionalUserEmailHelperText,
                    required: !isAdmin,
                    fieldProps: { validate: isAdmin ? emailOptional : email },
                    showError: showErrorOnBlur
                },
                textToObject: text => ({ email: text }),
                objectToText: object => object?.email,
                allowMultiple: true
            };
        }
        return {
            showDataTextbox: true,
            dataTextboxProps: {
                label: strings.phoneNumber,
                helperText: strings.lockSystemAdditionalUserPhoneNumberHelperText,
                required: !isAdmin,
                fieldProps: { validate: isAdmin ? phoneNumberOptional : phoneNumber },
                showError: showErrorOnBlur
            },
            textToObject: text => ({ phoneNumber: text }),
            objectToText: object => object?.phoneNumber,
            allowMultiple: true
        };
    }
    return {
        showDataTextbox: false,
        allowMultiple: false
    };
};

export const createBookingItemDataObject = (additionalService, storageSite, values) => {
    const configuration = getAdditionalServiceConfiguration(additionalService, storageSite);
    return configuration?.textToObject
        ? configuration.textToObject(values.data)
        : undefined;
};

export const createBookingItemDataText = (additionalService, storageSite, bookingItem) => {
    const configuration = getAdditionalServiceConfiguration(additionalService, storageSite);
    return configuration?.objectToText
        ? configuration.objectToText(bookingItem.data)
        : undefined;
};

export const getAdditionalServiceById = (additionalServices, id) => additionalServices?.find(o => o.id === id);
